import { isDemoUrl } from "../services/url-helpers";

/** This method looks at the url that the site is currently running under and chooses an Azure blob storage account accordingly */
export const determineStorageUrl=() => {
  const url = window.location.href;
  let storageUrl: string;

  if (url.includes("dev.thefoodchecker.com")) { // dev site
    storageUrl = "https://stpiukeuwdev3689.blob.core.windows.net";

  } else if (isDemoUrl(url)) { // sales demo site
    storageUrl = "https://stpisaleseuwdemoeaac.blob.core.windows.net";

  } else if (url.includes("thefoodchecker.com")) { // production site
    storageUrl = "https://stpiukeuwprodff41.blob.core.windows.net";

  } else { // fallback to dev site
    storageUrl = "https://stpiukeuwdev3689.blob.core.windows.net";
  }

  return storageUrl;
}
